import Link from 'next/link';

import {BodyText} from '@/components/Text';

export default function NeedHelpText() {
  return (
    <BodyText>
      Need help? <Link href="https://dagster.io/support">Visit Dagster Support</Link>
    </BodyText>
  );
}
